// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__HZOiu","rotation":"loader_rotation__xqCk2","loader-center-layer":"loader_loader-center-layer___0Bdr"};